"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var antd_1 = require("antd");
var reconnect_js_1 = require("reconnect.js");
var query_string_1 = __importDefault(require("query-string"));
var User = __importStar(require("../../Actions/User"));
function ConfirmPage(props) {
  var _this = this;
  var _a = props.pageContext.pageId,
    pageId = _a === void 0 ? 'rev-RegisterConfirmPage' : _a;
  var showLoginModal = reconnect_js_1.useOutletSetter('login-modal');
  var actions = reconnect_js_1.useOutlet('actions')[0];
  var _b = react_1.default.useState(null),
    requestResult = _b[0],
    setRequestResult = _b[1];
  var access_token = query_string_1.default.parse(props.location.search).access_token;
  var onFinish = function onFinish(values) {
    return __awaiter(_this, void 0, void 0, function () {
      var password1, password2, ex_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            password1 = values.password1, password2 = values.password2;
            if (password1 !== password2) {
              alert('密碼不相符, 請重新輸入');
              return [2 /*return*/];
            }

            _a.label = 1;
          case 1:
            _a.trys.push([1, 4, 5, 7]);
            return [4 /*yield*/, actions.setLoading(true)];
          case 2:
            _a.sent();
            return [4 /*yield*/, User.registerConfirm({
              password: password1.trim(),
              access_token: access_token
            })];
          case 3:
            _a.sent();
            setRequestResult(true);
            return [3 /*break*/, 7];
          case 4:
            ex_1 = _a.sent();
            console.log('EX', ex_1);
            setRequestResult(false);
            return [3 /*break*/, 7];
          case 5:
            return [4 /*yield*/, actions.setLoading(false)];
          case 6:
            _a.sent();
            return [7 /*endfinally*/];
          case 7:
            return [2 /*return*/];
        }
      });
    });
  };

  var onFinishFailed = function onFinishFailed(errorInfo) {
    console.log('Failed:', errorInfo);
  };
  var disableInput = requestResult === true;
  return react_1.default.createElement(Wrapper, {
    id: pageId
  }, react_1.default.createElement("div", {
    className: "content"
  }, react_1.default.createElement("h2", {
    style: {
      marginBottom: 10
    }
  }, "\u5B8C\u6210\u8A3B\u518A\u6D41\u7A0B"), requestResult === true && react_1.default.createElement("div", {
    className: "success",
    style: {
      padding: 15,
      borderRadius: 6,
      backgroundColor: '#eee',
      marginBottom: 15
    }
  }, react_1.default.createElement("h3", {
    style: {
      marginBottom: 10
    }
  }, "\u6210\u529F"), react_1.default.createElement("p", {
    style: {
      marginBottom: 15
    }
  }, "\u60A8\u7684\u5E33\u6236\u5DF2\u7D93\u5EFA\u7ACB, \u73FE\u5728\u53EF\u4EE5\u7528\u65B0\u5BC6\u78BC\u91CD\u65B0\u767B\u5165"), react_1.default.createElement(antd_1.Button, {
    onClick: function onClick() {
      return showLoginModal(true);
    }
  }, "\u767B\u5165")), requestResult === false && react_1.default.createElement("div", {
    className: "failure",
    style: {
      padding: 15,
      borderRadius: 6,
      backgroundColor: '#eee',
      marginBottom: 15
    }
  }, react_1.default.createElement("h3", {
    style: {
      marginBottom: 10
    }
  }, "\u5931\u6557"), react_1.default.createElement("p", null, "\u8ACB\u6C42\u5931\u6557, \u8ACB\u91CD\u65B0\u5617\u8A66\u4E00\u6B21")), requestResult !== true && react_1.default.createElement(antd_1.Form, {
    layout: "vertical",
    name: "register",
    onFinish: onFinish,
    onFinishFailed: onFinishFailed
  }, react_1.default.createElement(antd_1.Form.Item, {
    label: "\u5BC6\u78BC",
    name: "password1",
    rules: [{
      required: true,
      message: '請輸入密碼!'
    }]
  }, react_1.default.createElement(antd_1.Input.Password, {
    disabled: disableInput
  })), react_1.default.createElement(antd_1.Form.Item, {
    label: "\u518D\u6B21\u8F38\u5165\u5BC6\u78BC",
    name: "password2",
    rules: [{
      required: true,
      message: '請再次輸入密碼!'
    }]
  }, react_1.default.createElement(antd_1.Input.Password, {
    disabled: disableInput
  })), react_1.default.createElement(antd_1.Form.Item, {
    style: {
      textAlign: 'right'
    }
  }, react_1.default.createElement(antd_1.Button, {
    type: "primary",
    htmlType: "submit"
  }, "\u9001\u51FA")))));
}
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-top: var(--topNavBarHeight);\n\n  & > .content {\n    max-width: 600px;\n    margin: 20px auto;\n    padding: var(--basePadding);\n  }\n"], ["\n  padding-top: var(--topNavBarHeight);\n\n  & > .content {\n    max-width: 600px;\n    margin: 20px auto;\n    padding: var(--basePadding);\n  }\n"])));
exports.default = ConfirmPage;
var templateObject_1;